export const LOGIN = "LOGIN";

export const SET_USERS = "SET_USERS";
export const GET_MESSAGE = "GET_MESSAGE";
export const SET_MESSAGES = "SET_MESSAGES";

export const JOIN_ROOM = "JOIN_ROOM";
export const SET_ROOMS = "SET_ROOMS";
